import { useQuery } from '@tanstack/react-query';
import cloudFlare from '../../../services/cloudFlare';

/**
 * Fetch and cache user information (IP, geolocation).
 */
const useGetUserSessionInfo = () =>
  useQuery({
    queryKey: ['getUserSessionInfo'],
    queryFn: async () => {
      try {
        const cached = localStorage.getItem('userSessionInfo');
        let userInfo;
        if (!cached) {
          userInfo = await cloudFlare.getUserData();
          localStorage.setItem('userSessionInfo', JSON.stringify(userInfo));
        }
        else {
          userInfo = JSON.parse(cached) as Record<
            string,
            string
          >;
        }
        return userInfo;
      } catch (error) {
        throw new Error('Failed get user session info');
      }
    },
    refetchOnWindowFocus: false,
  });

export default useGetUserSessionInfo;
